import { capitalise } from './strings'

interface Params {
  lon: string
  lat: string
  locationName: string
  locationSlug: string
  slug: string
}

interface BreadcrumbItem {
  label: string
  url: string
  id: number
}

const getSearchUrl = ({ lat, locationName, locationSlug, lon, slug }: Params) => {
  const regexLocation = /location=([^&]+)/

  const chunks = slug.split('/')
  if (!chunks[3]) {
    const subPath = locationSlug || `ext-${lat}-${lon}`
    return `find/all/${subPath}/specialists#location=${locationName}`
  }
  let updatedSlug = slug.replace(chunks[3], locationSlug || `ext-${lat}-${lon}`)

  const locationMatch = slug.match(regexLocation)
  if (locationMatch) {
    const updatedLocation = encodeURIComponent(locationName)
    updatedSlug = updatedSlug.replace(regexLocation, `location=${updatedLocation}`)
  } else {
    const separator = updatedSlug.includes('?') ? '&' : '#'
    const updatedLocation = encodeURIComponent(locationName)
    updatedSlug = `${updatedSlug}${separator}location=${updatedLocation}`
  }

  const splittedChunks = updatedSlug.split('/')
  if (splittedChunks[splittedChunks.length - 1].startsWith('page-')) {
    updatedSlug = updatedSlug.replace(`/${splittedChunks[splittedChunks.length - 1]}`, `#${updatedSlug.split('#')[1]}`)
  }

  return `${updatedSlug}`
}

// @ts-ignore
export const generateBreadcrumb = (
  locale: string,
  locationName: string,
  lat: number,
  lon: number,
  locationsData: any,
  lang: string,
  slug?: string,
  breadcrumb: { label: string; url: string; id: number }[] = []
) => {
  if (!locationsData.name) {
    return []
  }
  breadcrumb.push({
    label: capitalise(locationsData.name[lang]),
    url: `/${locale}${getSearchUrl({
      lon: locationsData.lon,
      lat: locationsData.lat,
      locationName: locationsData.name[lang],
      locationSlug: locationsData.slug,
      slug: slug || ''
    })}`,
    id: locationsData.id
  })

  if (
    locationsData.name[lang] === locationName &&
    Number(locationsData.lon) === lon &&
    Number(locationsData.lat) === lat
  ) {
    return breadcrumb
  }

  if (locationsData.children) {
    for (let i = 0; i < locationsData.children.length; i += 1) {
      const result: BreadcrumbItem[] | null = generateBreadcrumb(
        locale,
        locationName,
        lat,
        lon,
        locationsData.children[i],
        lang,
        slug,
        breadcrumb.slice()
      )
      if (result) {
        return result
      }
    }
  }

  return null
}
